import {
  IGetAssigneeByRoleAndClientParams,
  IUpdateAssigneeByRoleAndClientParams,
} from "../../interfaces";
import ICMAxios from "../ICMAxios";

const getActiveInventorySessionAsync = async () => {
  const response = await ICMAxios.get(`v1/Inventory`);
  return response.data;
};

const createInventoryAsync = async (formData: any) => {
  const response = await ICMAxios.post(`v1/Inventory`, formData);
  return response.data;
};

const updateTagForceAudit = async (data: any) => {
  const response = await ICMAxios.put(`v1/Tag/forceaudit`, data);
  return response.data;
};
const excludeTagFromNextInventory = async (data: any) => {
  const response = await ICMAxios.put(`v1/Tag/excludetag`, data);
  return response.data;
};
const voidTag = async (data: any) => {
  const response = await ICMAxios.put(`v1/Tag/voidtag`, data);
  return response.data;
};

const lockInventoryAsync = async (inventoryId : any, requestFormData: any) => {
  const response = await ICMAxios.put(`v1/Inventory/${inventoryId}/lock`, requestFormData);
  return response.data;
};

const unLockInventoryAsync = async (inventoryId : any, requestFormData: any) => {
  const response = await ICMAxios.put(`v1/Inventory/${inventoryId}/unlock`, requestFormData);
  return response.data;
};
const getRecentlyLockedInventorySessionAsync = async () => {
  const response = await ICMAxios.get(`v1/Inventory/locked`);
  return response.data;
};

const getAllInventorySessionAsync = async (requestViewModel: any) => {
  const response = await ICMAxios.post(`v1/Inventory/locked`, requestViewModel);
  return response.data;
};

const copyInventoryAsync = async (inventoryId : any, requestViewModel: any) => {
  const response = await ICMAxios.post(`v1/Inventory/${inventoryId}/copy`, requestViewModel);
  return response.data;
};

const getAssigneeByRoleAndClientAsync = async (
  requestViewModel: IGetAssigneeByRoleAndClientParams
) => {
  const response = await ICMAxios.post(
    `v1/Inventory/assignees`,
    requestViewModel
  );
  return response.data;
};

const updateTagAssigneesAsync = async (
  requestViewModel: IUpdateAssigneeByRoleAndClientParams
) => {
  const response = await ICMAxios.put(
    `v1/Inventory/assignees`,
    requestViewModel
  );
  return response.data;
};

const exportTagsToExcelAsync = async (inventoryId: number) => {
  const response = await ICMAxios.get(`v1/Inventory/${inventoryId}/exportTags`);
  return response.data;
};

const getClientInventoriesByClientIdAsync = async () => {
  const response = await ICMAxios.get(`v1/Inventory/all`);
  return response.data;
};
const discardInventory = async (request: any) => {
  const response = await ICMAxios.post(`v1/Inventory/discard`,request);
  return response;
};

const inventoryService = {
  getActiveInventorySessionAsync,
  createInventoryAsync,
  updateTagForceAudit,
  excludeTagFromNextInventory,
  lockInventoryAsync,
  getRecentlyLockedInventorySessionAsync,
  getAllInventorySessionAsync,
  copyInventoryAsync,
  getAssigneeByRoleAndClientAsync,
  updateTagAssigneesAsync,
  exportTagsToExcelAsync,
  getClientInventoriesByClientIdAsync,
  voidTag,
  unLockInventoryAsync,
  discardInventory,
};
export default inventoryService;